/**
 * My Account scripts
 *
 */

/* On document ready actions */
jQuery(document).ready(function($) {

    /* [Edit address] Initialize the first options for the visible field on type customer */
    set_billing_fields_on_account(jQuery('.woocommerce-address-fields').closest('form'),true);

    /* [Edit address] Set visible fields on check type customer */
    jQuery(document).on("change", "[name='billing_bbvut_customer_type']", function () {
        set_billing_fields_on_account(jQuery(this).closest('form'));
    });

    /* [Edit address] Set customer type fields to work on the multi adress plugin popup */
    let billing_popup = document.getElementById("dsabafw_billing_popup");
    if(billing_popup) {
        let billing_popup_observer = new MutationObserver(function () {
            if (jQuery(billing_popup).css("display") === "block") {
                set_billing_fields_on_account(jQuery('#dsabafw_billing_popup'), true);
            }
        });
        billing_popup_observer.observe(billing_popup, {attributes: true, attributeFilter: ["style"]});
    }

    /* [Adresboek] Open modal + laad formulier (toevoegen of bewerken) */
    jQuery(document).on('click', '.bbvut-address-add, .bbvut-address-edit', function(e) {
        e.preventDefault();
        bbvut_open_address_modal(jQuery(this).data('address-id') || '');
    });

    /* [Adresboek] WooCommerce's eigen "Bewerk/Voeg factuur-/verzendadres toe"-
       link op de "Mijn adressen"-overzichtspagina hergebruikt (net als de
       eigen adresboek-knoppen) onze popup i.p.v. te navigeren naar de losse
       WC-edit-pagina — alleen als er al een adresboek-adres bekend staat als
       default voor dat type. Zonder match (nog geen adresboek-adres voor dit
       type) navigeert de link gewoon native door naar de WC-fallback-pagina
       (grondregel 3: altijd een werkende fallback). */
    jQuery(document).on('click', '.woocommerce-Address-title a.edit', function(e) {
        // Type bepalen via DOM-positie i.p.v. de href te parsen — WooCommerce's
        // eigen myaccount/my-address.php rendert altijd eerst het "billing"-blok
        // en dan "shipping" ($get_addresses = ['billing' => ..., 'shipping' => ...]),
        // dus de 1e .woocommerce-Address is billing en de 2e shipping. Een
        // href-substring-check (op '/edit-address/shipping/' of 'edit-address=shipping')
        // bleek onbetrouwbaar zodra de "edit-address"-endpoint-slug in
        // WooCommerce > Instellingen > Geavanceerd vertaald/aangepast is.
        const $addressBlock = jQuery(this).closest('.woocommerce-Address');
        const position = jQuery('.woocommerce-Address').index($addressBlock);
        const type = position === 1 ? 'shipping' : 'billing';
        const card = jQuery('.bbvut-address-card[data-is-default-' + type + '="1"]').first();

        if (!card.length) {
            return;
        }

        e.preventDefault();
        bbvut_open_address_modal(card.data('address-id'), type);
    });

    /* [Adresboek] Sluit modal */
    jQuery(document).on('click', '.bbvut-address-form-modal__close', function(e) {
        e.preventDefault();
        jQuery('#bbvut-address-modal').hide();
    });
    jQuery(document).on('click', '.bbvut-address-form-modal', function(e) {
        if (e.target === this) {
            jQuery(this).hide();
        }
    });

    /* [Adresboek] Formulier opslaan (toevoegen/bewerken) */
    jQuery(document).on('submit', '.bbvut-address-form', function(e) {
        e.preventDefault();

        const form = jQuery(this);
        loader(form);

        jQuery.ajax({
            url: ajax_object.url,
            type: 'post',
            data: form.serialize(),
            complete: function(response) {
                response = response.responseJSON;
                form.find('.loader-outside').remove();

                if (!response) {
                    return;
                }

                toast_from_response(response);

                if (response.status === true) {
                    if (response.list_html) {
                        jQuery('.bbvut-address-book__list-wrapper').html(response.list_html);
                    }
                    bbvut_replace_native_addresses(response.native_addresses_html);
                    jQuery('#bbvut-address-modal').hide();
                }
            }
        });
    });

    /* [Adresboek] Verwijderen — zonder page reload, kaart direct uit de lijst halen */
    jQuery(document).on('click', '.bbvut-address-delete', function(e) {
        e.preventDefault();

        if (!window.confirm(ajax_object.confirm_delete_address || 'Weet je zeker dat je dit adres wilt verwijderen?')) {
            return;
        }

        const card = jQuery(this).closest('.bbvut-address-card');
        loader(card);

        jQuery.ajax({
            url: ajax_object.url,
            type: 'post',
            data: {
                action: 'bbvut_delete_address',
                nonce: ajax_object.nonce,
                address_id: jQuery(this).data('address-id')
            },
            complete: function(response) {
                response = response.responseJSON;
                if (!response) {
                    return;
                }
                toast_from_response(response);
                if (response.status === true) {
                    card.remove();
                } else {
                    card.find('.loader-outside').remove();
                }
            }
        });
    });

    /* [Adresboek] Maak standaard factuur-/verzendadres */
    jQuery(document).on('click', '.bbvut-address-default', function(e) {
        e.preventDefault();

        const listWrapper = jQuery('.bbvut-address-book__list-wrapper');
        loader(listWrapper);

        jQuery.ajax({
            url: ajax_object.url,
            type: 'post',
            data: {
                action: 'bbvut_set_default_address',
                nonce: ajax_object.nonce,
                address_id: jQuery(this).data('address-id'),
                which: jQuery(this).data('which')
            },
            complete: function(response) {
                response = response.responseJSON;

                if (!response) {
                    listWrapper.find('.loader-outside').remove();
                    return;
                }

                toast_from_response(response);

                if (response.status === true) {
                    if (response.list_html) {
                        listWrapper.html(response.list_html);
                    } else {
                        listWrapper.find('.loader-outside').remove();
                    }
                    bbvut_replace_native_addresses(response.native_addresses_html);
                } else {
                    listWrapper.find('.loader-outside').remove();
                }
            }
        });
    });

});

/**
 * [Adresboek] Open de adresboek-modal en laad het toevoegen/bewerken-formulier.
 * Gedeeld tussen de eigen adresboek-knoppen en de onderschepte native WC
 * "Bewerk/Voeg ... adres toe"-links (zie hierboven).
 *
 * @param {string} addressId Leeg voor een nieuw adres.
 * @param {string|null} forceDefaultType 'billing'/'shipping': vink de
 *        bijbehorende default-checkbox meteen aan (native link had een
 *        specifiek adrestype als intentie), of null om niets te forceren.
 */
function bbvut_open_address_modal(addressId, forceDefaultType = null) {
    const modal = jQuery('#bbvut-address-modal');
    const content = modal.find('.bbvut-address-form-modal__content');

    loader(content);
    modal.show();

    jQuery.ajax({
        url: ajax_object.url,
        type: 'post',
        data: {
            action: 'bbvut_render_address_form',
            nonce: ajax_object.nonce,
            address_id: addressId || ''
        },
        complete: function(response) {
            content.find('.loader-outside').remove();
            content.html(response.responseText);
            set_billing_fields_on_account(content, true);
            jQuery(document.body).trigger('wc-enhanced-select-init');

            if (forceDefaultType) {
                content.find('[name="default_' + forceDefaultType + '"]').prop('checked', true);
            }
        }
    });
}

/**
 * [Adresboek] Vervang WooCommerce's eigen "Mijn adressen"-blok (de
 * factuur-/verzendadreskaarten die WC zelf boven onze adresboek-sectie
 * rendert) door de vers meegestuurde server-side render, zodat een
 * gewijzigd standaardadres meteen zichtbaar is zonder page reload.
 *
 * @param {string|undefined} html
 */
function bbvut_replace_native_addresses(html) {
    if (!html) {
        return;
    }

    const fresh = jQuery('<div>').html(html).find('.woocommerce-Addresses');
    if (fresh.length) {
        jQuery('.woocommerce-Addresses').replaceWith(fresh);
    }
}

/* Function for setting the visibility of fields in my account edit menu */
function set_billing_fields_on_account(element = null, init = false){
    const customer_type = element.find('#billing_bbvut_customer_type');
    const company_name = element.find('#billing_company');
    const vat_number = element.find('#billing_eu_vat_number');
    const kvk_number = element.find('#billing_bbvut_kvk_number');
    const custom_billing_email = element.find('#custom_billing_email');
    let type = customer_type.find(":selected").val();

    // Check on empty type
    if(type && init === true){
        type = company_name.val() !== '' ? 'company' : 'private';
        customer_type.val(type);
    }

    // Set visible fields
    switch(type) {
        case 'company':
        case 'government':
        case 'association':
            company_name.closest('p.form-row').removeClass('hidden');
            vat_number.closest('p.form-row').removeClass('hidden');
            kvk_number.closest('p.form-row').removeClass('hidden');
            if(custom_billing_email.length > 0) {
                custom_billing_email.closest('p.form-row').removeClass('hidden');
            }
            break;
        default:
            company_name.closest('p.form-row').addClass('hidden');
            vat_number.closest('p.form-row').addClass('hidden');
            kvk_number.closest('p.form-row').addClass('hidden');
            if(custom_billing_email.length > 0) {
                custom_billing_email.closest('p.form-row').addClass('hidden');
            }
    }
}